import i18n, { changeLanguage } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { registerComponentsI18n } from '@pandiafi/components'
import { registerDesignSystemI18n } from '@pandiafi/design-system'

import FIcommon from './locales/fi.common.json'
import ENcommon from './locales/en.common.json'
import SVcommon from './locales/sv.common.json'
import FIterminateContract from './locales/fi.terminate-contract.json'
import ENterminateContract from './locales/en.terminate-contract.json'
import SVterminateContract from './locales/sv.terminate-contract.json'
import FIcontractModification from './locales/fi.contract-modification.json'
import ENcontractModification from './locales/en.contract-modification.json'
import SVcontractModification from './locales/sv.contract-modification.json'
import FImessages from './locales/fi.messages.json'
import ENmessages from './locales/en.messages.json'
import SVmessages from './locales/sv.messages.json'
import FIErrors from './locales/fi.errors.json'
import ENErrors from './locales/en.errors.json'
import SVErrors from './locales/sv.errors.json'
import FINotifications from './locales/fi.notifications.json'
import SVNotifications from './locales/sv.notifications.json'
import ENNotifications from './locales/en.notifications.json'
import FIContact from './locales/fi.contact.json'
import ENContact from './locales/en.contact.json'
import SVContact from './locales/sv.contact.json'
import FIRegistration from './locales/fi.registration.json'
import ENRegistration from './locales/en.registration.json'
import SVRegistration from './locales/sv.registration.json'
import FIPayments from './locales/fi.payments.json'
import ENPayments from './locales/en.payments.json'
import SVPayments from './locales/sv.payments.json'
import FIManagePassword from './locales/fi.manage-password.json'
import ENManagePassword from './locales/en.manage-password.json'
import SVManagePassword from './locales/sv.manage-password.json'
import FIDefectNotice from './locales/fi.defect-notice.json'
import ENDefectNotice from './locales/en.defect-notice.json'
import SVDefectNotice from './locales/sv.defect-notice.json'
import FIQuestion from './locales/fi.question.json'
import ENQuestion from './locales/en.question.json'
import SVQuestion from './locales/sv.question.json'
import FIFeedback from './locales/fi.feedback.json'
import ENFeedback from './locales/en.feedback.json'
import SVFeedback from './locales/sv.feedback.json'
import FIDocuments from './locales/fi.documents.json'
import SVDocuments from './locales/sv.documents.json'
import ENDocuments from './locales/en.documents.json'
import FIFrontPage from './locales/fi.front-page.json'
import ENFrontPage from './locales/en.front-page.json'
import SVFrontPage from './locales/sv.front-page.json'
import FILogin from './locales/fi.login.json'
import ENLogin from './locales/en.login.json'
import SVLogin from './locales/sv.login.json'
import FItitles from './locales/fi.titles.json'
import ENtitles from './locales/en.titles.json'
import SVtitles from './locales/sv.titles.json'
import FIUserInfo from './locales/fi.user-info.json'
import ENUserInfo from './locales/en.user-info.json'
import SVUserInfo from './locales/sv.user-info.json'
import FIBulletins from './locales/fi.bulletins.json'
import ENBulletins from './locales/en.bulletins.json'
import SVBulletins from './locales/sv.bulletins.json'
import FIparking from './locales/fi.parking.json'
import SVparking from './locales/sv.parking.json'
import ENparking from './locales/en.parking.json'
import FIstorage from './locales/fi.storage.json'
import SVstorage from './locales/sv.storage.json'
import ENstorage from './locales/en.storage.json'
import FIreservations from './locales/fi.reservations.json'
import ENreservations from './locales/en.reservations.json'
import SVreservations from './locales/sv.reservations.json'
import FIgymBooking from './locales/fi.gymBooking.json'
import ENgymBooking from './locales/en.gymBooking.json'
import SVgymBooking from './locales/sv.gymBooking.json'

export const defaultNS = 'common'
export const resources = {
  fi: {
    common: FIcommon,
    terminateContract: FIterminateContract,
    contractModification: FIcontractModification,
    messages: FImessages,
    errors: FIErrors,
    notifications: FINotifications,
    contact: FIContact,
    registration: FIRegistration,
    payments: FIPayments,
    managePassword: FIManagePassword,
    defectNotice: FIDefectNotice,
    question: FIQuestion,
    feedback: FIFeedback,
    documents: FIDocuments,
    frontPage: FIFrontPage,
    login: FILogin,
    titles: FItitles,
    userInfo: FIUserInfo,
    bulletins: FIBulletins,
    parking: FIparking,
    storage: FIstorage,
    reservations: FIreservations,
    gymBooking: FIgymBooking,
  },
  en: {
    common: ENcommon,
    terminateContract: ENterminateContract,
    contractModification: ENcontractModification,
    messages: ENmessages,
    errors: ENErrors,
    notifications: ENNotifications,
    contact: ENContact,
    registration: ENRegistration, // todo
    payments: ENPayments,
    managePassword: ENManagePassword, // todo
    defectNotice: ENDefectNotice,
    question: ENQuestion,
    feedback: ENFeedback,
    documents: ENDocuments,
    frontPage: ENFrontPage, // todo
    login: ENLogin,
    titles: ENtitles,
    userInfo: ENUserInfo,
    bulletins: ENBulletins,
    parking: ENparking,
    storage: ENstorage,
    reservations: ENreservations,
    gymBooking: ENgymBooking,
  },
  sv: {
    common: SVcommon,
    terminateContract: SVterminateContract,
    contractModification: SVcontractModification,
    messages: SVmessages,
    errors: SVErrors,
    notifications: SVNotifications,
    contact: SVContact,
    registration: SVRegistration, // todo
    payments: SVPayments,
    managePassword: SVManagePassword, // todo
    defectNotice: SVDefectNotice,
    question: SVQuestion,
    feedback: SVFeedback,
    documents: SVDocuments,
    frontPage: SVFrontPage, // todo
    login: SVLogin,
    titles: SVtitles,
    userInfo: SVUserInfo,
    bulletins: SVBulletins,
    storage: SVstorage,
    parking: SVparking,
    reservations: SVreservations,
    gymBooking: SVgymBooking,
  },
} as const

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    debug: false,
    fallbackLng: 'fi',
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources,
    defaultNS,
    detection: {
      lookupQuerystring: 'lang', // default is lng
      lookupCookie: 'lang',
      lookupSessionStorage: 'lang', // default: i18nextLng
      order: ['querystring', 'cookie', 'sessionStorage', 'htmlTag'], // IMPORTANT
      lookupFromPathIndex: 0,
    },
    supportedLngs: Object.keys(resources),
    returnNull: true,
    lowerCaseLng: true,
  })

registerComponentsI18n(i18n)
registerDesignSystemI18n(i18n)

export default i18n

export type Language = keyof typeof resources
export const Languages = Object.keys(resources) as Language[]

export const toSupportedLanguage = (lng?: string): Language =>
  Languages.includes(lng as Language) ? (lng as Language) : 'fi'

export const changeI18nLanguage = async (lng: Language) => {
  await changeLanguage(lng)
  sessionStorage.setItem('lang', lng)
  return lng
}
